import styled from 'styled-components';
import { TabPanel, Tabs } from '../../../CommonComponents/OPL/Tab';

export const StyledTabs = styled(Tabs)({
  overflowY: 'hidden',
  display: 'flex',
  flexDirection: 'column',
});

export const StyledTabPanel = styled(TabPanel)({
  overflowY: 'hidden',
  display: 'flex',
  flexDirection: 'column',
});
